import React from 'react';
import { ReactComponent as Keyboard } from './keyboard.svg';
import { ReactComponent as Code } from './code.svg';
import { ReactComponent as JS } from './js.svg';
import { ReactComponent as ReactSVG } from './react.svg';
import { ReactComponent as Git } from './git.svg';
import { ReactComponent as Sql } from './sql.svg';
import { ReactComponent as Html } from './html.svg';
import { ReactComponent as Battery } from './battery.svg';
import { ReactComponent as Time } from './time.svg';
import { ReactComponent as Flask } from './flask.svg';
import { ReactComponent as Paper } from './paper.svg';
import { ReactComponent as Coffee } from './coffee.svg';
import { ReactComponent as Web } from './web.svg';
import { ReactComponent as Home } from './home.svg';
import { ReactComponent as Bike } from './bike.svg';
import { ReactComponent as Weight } from './weight.svg';
import { ReactComponent as Heart } from './heart.svg';
import { ReactComponent as Game } from './game.svg';
import { ReactComponent as Cloud } from './cloud.svg';
import { ReactComponent as Mic } from './mic.svg';

const Icons = () => {
  return (
    <div>
      <Code />
      <JS />
      <ReactSVG />
      <Keyboard />
      <Git />
      <Sql />
      <Coffee />
      <Html />
      <Battery />
      <Time />
      <Paper />
      <Home />
      <Bike />
      <Weight />
      <Heart />
      <Flask />
      <Web />
      <Game />
      <Cloud />
      <Mic />
    </div>
  );
};

export default Icons;